import React, { Component } from 'react'
import CollapseIconButton from 'components/fulcrum/collapse/CollapseIconButton'
import { IconButton } from 'react-toolbox/lib/button'
import { Flex } from 'reflexbox'
import CSSModules from 'helpers/CSSModulesUtil'
import ModifyIconButton from './ModifyIconButton'
import showOnAnyRoles from 'containers/Role/Show/AnyGlobalRoles'
import { PROJECT_ROLES, PRODUCT_ROLES, GLOBAL_ROLES } from 'containers/Role/constants'
import { mapProps, compose } from 'recompose'
import styles from './styles.scss'
import ProgressBar from 'react-toolbox/lib/progress_bar';
import CancelEditButton from './CancelEditButton'
import notifyHoc from 'containers/App/Notification/Notify'
import T from 'i18n-react'
import { setActive } from 'containers/Project/FileUploadDialogNvqual/actions'
import { connect } from 'react-redux'
import { nvqualDetailsLoadingSelector, currentRevisionSelector } from './selectors'
import { onSaveNvqualCurStatus } from './actions'
const InfoButton = notifyHoc(IconButton)

const showToTeam = compose(
  mapProps((props) => ({
    ...props,
    roles: [ 
      ...Object.values(PROJECT_ROLES),
      ...Object.values(PRODUCT_ROLES),
      GLOBAL_ROLES.ADMIN_ACCESS
    ]
  })),
  showOnAnyRoles
)

const EditButton = showToTeam(ModifyIconButton)

const mapStateToProps = (state) => {
  return {
    isLoading: nvqualDetailsLoadingSelector(state),
    curRevision: currentRevisionSelector(state),
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    onAdd: () => dispatch(setActive()),
    onSave: () => (dispatch(onSaveNvqualCurStatus())),
  }
}


class Actions extends React.Component {

  render () {

    const {
      toggleCollapse,
      collapse,
      onAdd,
      isLoading,
      edit,
      toggleEdit,
      onSave,
      curRevision,
      toggleRevisionDialog
    } = this.props

    if (isLoading) return (<ProgressBar type="circular" mode="indeterminate" theme={styles}/> )

    return (
      <Flex justify='flex-end'>
        {curRevision && 
          <React.Fragment>
            {edit &&
              <CancelEditButton
                onClick={toggleEdit}
              />
            }
            <EditButton
              toggleEdit={() => {
                toggleEdit()
              }}
              edit={edit}
              onSave={() => onSave()}
            />
            {/* <InfoButton
              icon='add'
              message={T.translate('pages.project.view.notification.nvqual_add')}
              onClick={onAdd}
              className={styles.infoButton}
            /> */}
            <InfoButton
              icon='list'
              message={T.translate('pages.project.view.notification.nvqual_change_rev')}
              onClick={toggleRevisionDialog}
              className={styles.infoButton}
            />
          </React.Fragment>
        }
        <CollapseIconButton
          toggleCollapse={toggleCollapse}
          collapse={collapse}
          className={styles.infoButton}
        />
      </Flex>
    )
  }
}

const withConnect = connect(mapStateToProps, mapDispatchToProps)
const withStyles = CSSModules(styles);
const enhance = compose(withConnect, withStyles);
export default enhance(Actions);
